import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import {XYZ} from 'ol/source';
import {fromLonLat} from 'ol/proj';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import {get as getProjection} from 'ol/proj';

import * as THREE from 'three';

export class MapCanvasProjection {

  constructor({
    scene,
    parameters,
    oversize = 1.0,
    overscale = 1.0
  }){

    this.scene = scene;
    this.parameters = parameters;

    proj4.defs(parameters.name, parameters.projection);
    register(proj4);
    const proj = getProjection(parameters.name);
  
    const [topLeftX, topLeftY] = fromLonLat([parameters.corners[0], parameters.corners[1]], proj);
    const [botRightX, botRightY] = fromLonLat([parameters.corners[2], parameters.corners[3]], proj);
  
    const width = botRightX - topLeftX;
    const height = botRightY - topLeftY;
    const centerX = topLeftX + width / 2;
    const centerY = topLeftY + height / 2;
  
    const extent = [
      centerX - width / 2 * oversize,
      centerY - height / 2 * oversize,
      centerX + width / 2 * oversize,
      centerY + height / 2 * oversize
    ];
  
    this.oversizedWidth = parameters.dimensions[1] * oversize;
    this.oversizedHeight = parameters.dimensions[0] * oversize;
  
    proj.setExtent(extent);
    let mapID = 'projection-map-' + parameters.name.toLowerCase().replace(' ', '-');
    let mapDiv = document.createElement('div');
    mapDiv.id = mapID;
    mapDiv.style['display'] = 'none';
    document.body.appendChild(mapDiv);
    const map = new Map({
      target: mapID,
      layers: [
          new TileLayer({
          source: new XYZ({
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            crossOrigin: 'Anonymous'
          }),
        })
      ],
      view: new View({
        projection: proj,
        center: [centerX, centerY]
      })
    });
    map.getControls().forEach(function(control) {
      map.removeControl(control);
    }, this);
    map.getInteractions().forEach(function(interaction) {
      interaction.setActive(false);
    }, this);
    map.setSize([this.oversizedWidth * overscale, this.oversizedHeight * overscale]);
    map.getView().fit(extent, {size: map.getSize()});
  
    map.on('postrender', this.postrender.bind(this));

    this.map = map;

  }

  postrender(){
    if(this.plane === undefined){
      const canvas = this.map.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer')[0];
      this.texture = new THREE.CanvasTexture(canvas);
      const material = new THREE.MeshBasicMaterial({ map: this.texture });
      const geometry = new THREE.PlaneGeometry(this.oversizedWidth, this.oversizedHeight);
      geometry.translate(this.parameters.dimensions[1] / 2 - 0.5, this.parameters.dimensions[0] / 2 - 0.5, 0);
      this.plane = new THREE.Mesh(geometry, material);
      this.scene.add(this.plane);
    }
    this.texture.needsUpdate = true;
  }

}